import React from 'react';
import { useTranslation } from 'react-i18next';
import Loading from '../../../../general/Loading';

export default function CashoutProcessing() {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div
      className="phoenix-simple-dialog-view modal member-diamonds-cash-confirm in show"
      aria-hidden="false"
    >
      <div className="modal-backdrop fade in" />
      <div className="modal-dialog">
        <div className="modal-content modal-content-sw">
          <div className="cashout-processing text-center">
            <div className="modal-header">
              <h4 className="modal-title" id="cashout-processing-title">
                {t('cashout_processing')}
              </h4>
            </div>

            <div className="modal-body">
              <Loading />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
